import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import Loader from "../../../../../components/common/loader";
import BookCard from "../../../../common/book-card";
import { useTranslation } from "react-i18next";
import { Button, UncontrolledCollapse } from "reactstrap";
import { FREE_LIMIT } from "../../../../../common/constants";

const Featured = (props) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    loadData();
  }, [language, props.browserFilter]);

  function loadData() {
    props.getNovelties().then((data) => {
      setItems(data);
      setIsLoading(false);
    });
  }

  return (
    <div>
      <h2>
        {t("featured")}{" "}
        <Link type="button" className="btn btn-light btn-sm" to="/literature">
          {t("explore")}...
        </Link>
      </h2>

      <div>
        <h2>
          <Button color="outline-success" id="toggler" size="sm">
            {t("how-to-order-offer")}
          </Button>
        </h2>
        <UncontrolledCollapse toggler="#toggler">
          <div className="alert alert-warning">
            <p
              dangerouslySetInnerHTML={{
                __html: t("literature-warning", {freeLimit: FREE_LIMIT}),
              }}
            ></p>
            <p className="text-justify">
                          {t("email-subscription")}{"  "}
                                        <Link className="btn btn-outline-secondary btn-sm" to="/subscriptions">
                                          {t("subscribe")}
                                        </Link>
                        </p>
            <p>
              <Link
                type="button"
                className="btn btn-primary btn-sm"
                to="/literature"
              >
                {t("explore")}...
              </Link>
            </p>
            <Link
              to="/about/distributors"
              className="btn btn-outline-secondary btn-sm"
            >
              {t("how-to-order")}
            </Link>{" "}
            <span>{t("literature-warning-2")}</span>
          </div>
          <p className="text-justify">
            <span> {t("literature-header")}</span>{" "}
            <Link to="/donate" className="btn btn-outline-primary btn-sm">
              {t("donate")}
            </Link>
          </p>
        </UncontrolledCollapse>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "nowrap",
          overflowX: "auto",
          paddingBottom: "15px",
          minHeight: "350px",
          gap: "15px",
        }}
      >
        {isLoading && <Loader height="500" />}
        {!isLoading &&
          items.length > 0 &&
          items.map((b) => (
            <div key={b.id}>
              <BookCard book={b} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default Featured;
